// removed by extract-text-webpack-plugin
module.exports = {"anchorList":"_2AzW8N-6XmionLVndaPhnk","accordion":"YqHeCwoo3lv7xF82FQGu0","wrapper":"_13WTVbadCtM-Wy_IgrJ8gc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AnchorList/AnchorList.scss
// module id = 1567
// module chunks = 0